import { render, staticRenderFns } from "./ApplicationCard.vue?vue&type=template&id=4fa28481&scoped=true"
import script from "./ApplicationCard.vue?vue&type=script&lang=js"
export * from "./ApplicationCard.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCard.vue?vue&type=style&index=0&id=4fa28481&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa28481",
  null
  
)

export default component.exports